<template>
  <v-flex px-2>
    <v-flex style="border-bottom: 0px solid black">
      <v-flex pb-1>
        <h4>The purpose of this form is to identify and support Mesa Public Schools students who may be eligible to receive services in accordance with the McKinney-Vento Act 42 U.S.C. 11435. Eligibility must be reviewed and reevaluated every school year. The information on this form is confidential. If you have questions or concerns, call (480) 472-0291.</h4>
      </v-flex>
      <v-layout row wrap px-2>
        <v-flex
          xs12
          md12
          lg8
          py-4
        >Do you have additional children attending Preschool to 12th grade in Mesa Public Schools?</v-flex>
        <v-flex xs12 md12 lg4 px-2>
          <v-radio-group :rules="booleanRule" v-model="has_additional_children" row>
            <v-radio label="Yes" v-bind:value="true"></v-radio>
            <v-radio label="No" v-bind:value="false"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex style="border-bottom: 0px solid black">
      <v-flex py-3>
        <h4>Please answer these screening questions to determine if the student might qualify for homeless support services:</h4>
      </v-flex>
      <v-flex>
        <h4>Question #1:</h4>
      </v-flex>
      <v-layout row wrap px-2>
        <v-flex
          xs12
          md12
          lg8
          py-4
        >Does the student lack a fixed, regular, or adequate nighttime residence?</v-flex>
        <v-flex xs12 md12 lg4 px-2>
          <v-radio-group :rules="booleanRule" v-model="is_question_1_yes" row>
            <v-radio label="Yes" v-bind:value="true"></v-radio>
            <v-radio label="No" v-bind:value="false"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-flex>
        <p>
          <i>Examples: hotel; shelter; transitional housing; sharing the housing of others due to loss of housing, economic hardship or similar reason; car; park; campsite</i>
        </p>
      </v-flex>
    </v-flex>

    <v-flex style="border-bottom: 01px solid black">
      <v-flex py-3>
        <h4>Please answer these screening questions to determine if the student might qualify for homeless support services:</h4>
      </v-flex>
      <v-flex>
        <h4>Question #2:</h4>
      </v-flex>
      <v-layout row wrap px->
        <v-flex
          xs12
          md12
          lg8
          py-4
        >Does the student live alone or with someone other than his or her biological or adoptive parent or a legal guardian due to loss of housing or economic hardship, incarceration or deportation of parent or legal guardian, or abandonment by parent or legal guardian?</v-flex>
        <v-flex xs12 md12 lg4 px-2 py-3>
          <v-radio-group :rules="booleanRule" v-model="is_question_2_yes" row>
            <v-radio label="Yes" v-bind:value="true"></v-radio>
            <v-radio label="No" v-bind:value="false"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-flex px->
        <p>
          <i>
            Please note: A
            <u>legal guardian</u> is a person appointed by a court to care for a student.
          </i>
        </p>
      </v-flex>
    </v-flex>

    <v-flex px-3 py-3 style="border: 1px solid black" v-if="is_question_1_yes || is_question_2_yes">
      <v-flex>
        <h4>CURRENT LIVING ARRANGEMENTS</h4>
        <p>
          Because you answered “
          <b>Yes</b>” to either Question #1 or Question #2 above, please provide the following information to indicate where the student is currently living.
        </p>
      </v-flex>

      <v-flex>
        <v-flex>
          <v-radio-group :rules="validationRules" v-model="living_in">
            <v-radio label="In a hotel/motel." value="hotel/motel"></v-radio>
            <v-radio label="In a shelter or transitional housing program." value="shelter"></v-radio>
            <v-radio
              label="In a place not designated for ordinary sleeping accommodations such as a car, park, or campsite."
              value="unordinary"
            ></v-radio>
            <v-radio
              label="In shared housing with another family in their home due to loss of housing, economic hardship, or similar reason."
              value="shared housing"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex>
          <v-text-field
            v-if="living_in == 'hotel/motel'"
            :rules="validationRules"
            name="hotel_name"
            label="Name and location of hotel/motel:"
            box
            v-model="hotel_name"
          ></v-text-field>
          <v-text-field
            v-if="living_in == 'shelter'"
            :rules="validationRules"
            name="shelter_name"
            label="Name of shelter or program:"
            box
            v-model="shelter_name"
          ></v-text-field>
        </v-flex>
        <v-text-field
          v-if="living_in == 'shared housing'"
          :rules="validationRules"
          name="shared_housing_start_date"
          label="What date did shared housing begin?"
          box
          v-model="shared_housing_start_date"
        ></v-text-field>
      </v-flex>

      <v-layout row wrap>
        <v-flex lg6>
          <v-radio-group
            :row="!$vuetify.breakpoint.xsOnly"
            :rules="validationRules"
            label="Choose type:"
            v-model="watcher_type"
          >
            <v-radio label="Parent" value="Parent"></v-radio>
            <v-radio label="Guardian" value="Guardian"></v-radio>
            <v-radio label="Caregiver" value="Caregiver"></v-radio>
            <v-radio label="Host" value="Host"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex>
          <v-text-field
            name="name_of_watcher"
            label="Name of Parent/Guardian/Caregiver/Host"
            box
            :rules="validationRules"
            v-model="name_of_watcher"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-flex>
        <v-text-field
          name="address_of_watcher"
          label="Address of Parent/Guardian/Caregiver/Host"
          box
          :rules="validationRules"
          v-model="address_of_watcher"
        ></v-text-field>
      </v-flex>
      <v-layout>
        <v-flex pr-1>
          <v-text-field
            name="email_of_watcher"
            label="Email of Parent/Guardian/Caregiver/Host"
            box
            :rules="emailRules"
            v-model="email_of_watcher"
          ></v-text-field>
        </v-flex>
        <v-flex pl-1>
          <v-text-field
            name="phone_of_watcher"
            label="Phone of Parent/Guardian/Caregiver/Host"
            box
            :rules="validationRules"
            mask="(###) ### - ####"
            v-model="phone_of_watcher"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>


<script>
export default {
  props: {},
  data() {
    return {
      booleans: [
        {
          text: "Yes",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ],
      booleanRule: [v => v===true || v===false || 'Field is required'],
      validationRules: [v => !!v || "Field is required"],
      emailRules: [v => /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v) || "A valid email is required"]
    };
  },
  computed: {
    has_additional_children: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .has_additional_children;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setHasAdditionalChildren",
          value
        );
      }
    },
    is_question_1_yes: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .is_question_1_yes;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setIsQuestion1Yes",
          value
        );
      }
    },
    is_question_2_yes: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .is_question_2_yes;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setIsQuestion2Yes",
          value
        );
      }
    },
    living_in: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .living_in;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setLivingIn",
          value
        );
      }
    },
    hotel_name: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .hotel_name;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setHotelName",
          value
        );
      }
    },
    shelter_name: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .shelter_name;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setShelterName",
          value
        );
      }
    },
    shared_housing_start_date: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .shared_housing_start_date;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setSharedHousingStartDate",
          value
        );
      }
    },
    watcher_type: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .watcher_type;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setWatcherType",
          value
        );
      }
    },
    name_of_watcher: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .name_of_watcher;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setWatcherName",
          value
        );
      }
    },
    address_of_watcher: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .address_of_watcher;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setWatcherAddress",
          value
        );
      }
    },
    email_of_watcher: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .email_of_watcher;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setWatcherEmail",
          value
        );
      }
    },
    phone_of_watcher: {
      get() {
        return this.$store.state.registration.studentReferralQuestionnaire
          .phone_of_watcher;
      },
      set(value) {
        this.$store.commit(
          "registration/studentReferralQuestionnaire/setWatcherPhone",
          value
        );
      }
    }
  }
};
</script>
